import { gql } from '@apollo/client'

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($login: String!) {
    forgotPassword(login: $login)
  }
`
